module.exports = __webpack_public_path__ + "images/assets/f20158e0c749ee406d7e2803c507893c.svg";